import { render, staticRenderFns } from "./pemberitahuan-kewenangan.vue?vue&type=template&id=44baeb65&"
import script from "./pemberitahuan-kewenangan.vue?vue&type=script&lang=js&"
export * from "./pemberitahuan-kewenangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports